import { persistCombineReducers } from 'redux-persist'
import { miscReducer } from './misc'
import storage from 'redux-persist/lib/storage'
import { MiscState } from './misc/reducer'
import { requestsReducer, RequestsState } from './requests'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['misc'],
}

export type MainState = {
  misc: MiscState
  requests: RequestsState
}

export default persistCombineReducers<MainState>(persistConfig, {
  misc: miscReducer as any,
  requests: requestsReducer as any,
})
